<template>
  <div class="btn-bottom-margin">
    <h1 class="header-style">
      Attendance
    </h1>
    <div v-if="tab === 0">
      <p class="subheader-style">
        List of all check-ins
      </p>
    </div>
    <div v-if="tab === 1">
      <p class="subheader-style">
        List of all absentees
      </p>
    </div>
    <div>
      <v-tabs
        v-model="tab"
        class="tab-style mt-5"
        rounded
        color="transparent"
        active-class="selected-tab"
        light
      >
        <v-tab
          class="tab-check-in"
        >
          <v-icon size="15">
            mdi-check-circle-outline
          </v-icon> Attendees
        </v-tab>
        <v-tab
          class="tab-pending"
        >
          <v-icon size="15">
            mdi-clock-outline
          </v-icon> Absentees
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        class="my-tabs-background-style"
        touchless
      >
        <v-tab-item>
          <v-card-text>
            <on-site-attendence />
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <off-site-attendence />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
      <br>
      <br>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>
<script>
import moment from 'moment';
import spinner from 'src/views/components/SpinnerCentre';
import OnSiteAttendence from './dialogComponents/AttendenceDialogs/OnSiteAttendence.vue';
import OffSiteAttendence from './dialogComponents/AttendenceDialogs/OffSiteAttendence.vue';
export default {
  name: 'AppUserProjects',
  components: {
    'centre-spinner': spinner,
    'on-site-attendence': OnSiteAttendence,
    'off-site-attendence': OffSiteAttendence,
  },
  data: () => ({
    loading: false,
    fromCalendar: false,
    maxStartDate: moment().format('YYYY-MM-DD'),
    fromDate: moment().format('YYYY-MM-DD'),
    selectedOrganization: null,
    tab: null,
  }),
};
</script>

<style scoped>
.from-style {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.my-tabs-background-style {
  background-color: transparent;
}

.v-item-group
  theme--dark
  v-slide-group
  v-tabs-bar
  v-tabs-bar--is-mobile
  primary--text {
  width: 100%;
}

.v-slide-group__content v-tabs-bar__content {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.v-tabs-slider-wrapper {
  background-color: transparent !important;
}

.v-tab {
  color: #000000 !important;
  border-radius: 10px;
  height: 30px;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  gap: 10px;
  background: #FFF;
}

.v-tab.tab-pending {
  width: 40% !important;
  border: 1px solid #ffca68;
}

.v-tab--active.tab-pending {
  color: #ffffff !important;
  background: #ffca68;
  border: none;
}

.v-tab.tab-check-in {
  width: 40% !important;
  border: 1px solid #63ca7f;
}

.v-tab--active.tab-check-in {
  color: #ffffff !important;
  background: #63ca7f;
  border: none;
}

.selected-tab {
  color: #fff;
}

.v-tab {
  font-size: 12px !important;
}

.v-card__text {
  padding: 0px !important;
}
</style>
